export const trackInhouseEvent = (data: object) => {
    const payload = JSON.stringify(data)

    navigator.sendBeacon('/api/evt/v1/events', payload)
}
